import React, { Fragment, useEffect, useReducer, useState } from 'react';
import { Container } from '@philips-internal/oswald-ui-core';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { useIsXSmallResolution } from '../../../../hooks/use-is-xsmall-resolution.js';
import { CollapseArrow } from '../../../collapse-arrow/collapse-arrow.js';
import { HeadingAction } from '../heading-action/heading-action.js';
import { getActions, getFilterAction } from '../heading-context/heading-context-utils.js';
import { useHeading } from '../heading-context/heading-context.js';
import { HeadingOptions } from '../heading-options/heading-options.js';
import './heading-actions.css';
function onCollapseButtonClick(event, callback) {
    if (!isFunction(callback)) {
        return;
    }
    event.stopPropagation();
    callback();
}
function actionsReducer(data, partialData) {
    return {
        ...data,
        ...partialData,
    };
}
const reducerInitialState = { excess: [], filter: null, inline: [] };
const HeadingActionsContainer = {
    name: 'actions',
};
function HeadingActions(props) {
    const context = useHeading();
    const isXSmallResolution = useIsXSmallResolution();
    const [actions, setActions] = useState(() => {
        return context.getActions();
    });
    const [reducerActions, setReducerActions] = useReducer(actionsReducer, reducerInitialState);
    useEffect(() => {
        const unlisten = context.addActionListener(() => {
            setActions(context.getActions());
        });
        setActions(context.getActions());
        return () => {
            if (!isFunction(unlisten)) {
                return;
            }
            unlisten();
        };
    }, []);
    useEffect(() => {
        if (!actions || !actions?.length) {
            return setReducerActions(reducerInitialState);
        }
        const { excess, inline } = getActions(actions, props.inlineLimit, props.showCollapseButton);
        const filter = getFilterAction(actions);
        return setReducerActions({ excess, filter, inline });
    }, [actions, props.inlineLimit, isXSmallResolution]);
    const inlineElements = reducerActions.inline.length > 0
        ? reducerActions.inline.map(action => React.createElement(HeadingAction, { action: action, key: action.id }))
        : [];
    const excessElement = reducerActions.excess.length > 0
        ? React.createElement(HeadingOptions, { actions: reducerActions.excess, key: "heading-options" })
        : null;
    const filterElement = reducerActions.filter
        ? React.createElement(HeadingAction, { action: reducerActions.filter, key: reducerActions.filter.id })
        : null;
    const collapseElement = props.showCollapseButton
        ? React.createElement(CollapseArrow, { collapsed: Boolean(props.collapsed), onClick: (event) => onCollapseButtonClick(event, props.onCollapseButtonClick) })
        : null;
    return (React.createElement(Fragment, null,
        isXSmallResolution ? null : filterElement,
        props.hideActions
            ? collapseElement
            : React.createElement(Container, { acceptedTypes: props.acceptedTypes, className: "c-heading__actions u-expand", slot: HeadingActionsContainer.name, uuid: props.uuid },
                isXSmallResolution ? filterElement : null,
                inlineElements,
                excessElement,
                collapseElement)));
}
export { HeadingActions, HeadingActionsContainer, };
//# sourceMappingURL=heading-actions.js.map